<template>
  <div class="form-container">
    <div class="justify-center">
      <div class="mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]">
        <FormKit
          type="form"
          @submit="submitHandler"
          #default="{ value }"
          :value="true"
          :actions="false"
          incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
        >
          <FormKit
            type="autocomplete"
            label="Fournisseur*"
            name="supplier"
            validation="required"
            :validation-messages="{
              required: 'Veuillez sélectionner un fournisseur.',
            }"
            placeholder="Sélectionner un fournisseur"
            :options="searchSuppliers"
            v-model="supplier_model"
          />
          <FormKit
            type="autocomplete"
            label="Produit*"
            name="variantProduct"
            validation="required"
            :validation-messages="{
              required: 'Veuillez sélectionner un produit.',
            }"
            placeholder="Sélectionner un produit"
            :options="optionsProducts"
          />
          <FormKit
            type="file"
            label="Vos documents*"
            help="Sélectionnez les documents à uploader."
            accept=".csv"
            placeholder="Pas de fichier sélectionné."
            validation="required|validateFileExtension:csv"
            :validation-messages="{
              required: 'Aucun fichier sélectionné.',
              validateFileExtension: 'Le fichier doit être au format CSV.'
            }"
            name="file"
          />

          <FormKit type="hidden" name="csvFilePath" />
          <div class="flex mt-[1.5rem]">
            <FormKit
              type="submit"
              label="Importer"
              class="btn"
              prefix-icon="check"
            />
          </div>
        </FormKit>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ApiService from "@/_services/api.service";
import { ref, watch } from "vue";
import router from "@/router";
import swal from "@/_helpers/swal";
import { ucfirst } from "@/_helpers/stringManipulations";
import { searchSuppliers } from "@/_services/supplier/supplier";

const props = defineProps({
  importType: {
    type: String,
    required: true,
  },
  importRoute: {
    type: String,
    required: true,
  },
})

let supplier_model = ref('');
let optionsProducts = ref([]);

async function fetchProductsBySupplier(supplierUuid) {
  if (!supplierUuid) {
    optionsProducts.value = [];
    return;
  }
  try {
    const response = await ApiService.get(`/variant-product-filter?supplierUuid=${supplierUuid}&prototypes[]=6a3f537e-fdfd-11ed-a0b1-de1c3c38600f&prototypes[]=6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f&prototypes[]=6a3fe435-fdfd-11ed-a0b1-de1c3c38600f&sortBy=adminProductName&isDefault=0`);
    optionsProducts.value = response.data.data.map((val: any) => {
      let productName = val?.properties?.adminProductName ? val.properties.adminProductName[0]?.value : '';
      productName = productName? productName : ' ';
      if (!val?.status?.active) {
        productName = 'Inactif -  ' + productName;
      }
      productName= val.isTechnical ? 'Technique - ' + productName : productName;
      return {
        label: productName,
        value: val.uuid,
      }
    });
  } catch (error) {
    //console.error("Error fetching products:", error);
  }
}

watch(
  supplier_model,
  (newSupplierUuid) => {
    fetchProductsBySupplier(newSupplierUuid);
  }
);


function submitHandler(data,formNode) {
  const filename = data.file[0].file.name;
  const errorMessage = 'Fichier au mauvais format';
  let formatError = null;
  if (filename.endsWith(".csv")) {
    const form = new FormData();
    form.append('file', data.file[0].file);
    form.append('variantProduct', '/api/variant-product/' + data.variantProduct);
    return ApiService.post(`/${props.importRoute}`, form)
      .then(({data}) => {
        swal.success(`${ucfirst(props.importType)} importé !`, "");
        router.push({name: `List${ucfirst(props.importType)}s`})
      })
      .catch(({response}) => {
        let contentError = null;
        if (response) {
          response.data.errors.forEach((error) => {
            if (error.message === 'Fichier au mauvais format') {
              formatError = error.message;
            } else {
              contentError = error.message;
            }
          });
          if (formatError) {
            formNode.setErrors(
              null,
              {
                file: formatError
              }
            );
          } else if (contentError) {
            formNode.setErrors(
              null,
              {
                file: contentError
              }
            );
          }
        } else {
          formatError = "format non valide";
        }
      });
  } else {
    formatError = errorMessage;
  }
}
</script>

<style scoped>
.formkit-option {
  background-color: red !important;
}

select {
  background-color: pink;
}
</style>
